import { useState, useEffect } from 'react';
import { useStore } from '@app/react-common/StoreContext';
import { ICheckoutExtensions } from '@pdqdev/pdq-shared/dist/interfaces/ICheckoutExtensions';

const useExtensions = () => {
  const [extensions, setExtensions] = useState<ICheckoutExtensions[]>([]);
  const { extensions$ } = useStore();

  useEffect(() => {
    if (!extensions$) return;

    const subscription = extensions$.subscribe((extensionsData) => {
      if (extensionsData) {
        setExtensions(extensionsData as ICheckoutExtensions[]);
      }
    });

    return () => {
      subscription.unsubscribe();
    };
  }, [extensions$]);

  return {
    extensions,
  };
};

export default useExtensions;
